import React from 'react';
import { SVGIcon } from '@superops/super-icons';

const getEntityIcon = (ent) => {
  switch (ent) {
    case 'Ticket':
      return {
        badgeColor: '#F8E3E1',
        icon: (
          <div className="flex-center" title={ent}>
            <SVGIcon name="TicketOutline" color="#ED0050" />
          </div>
        )
      };
    case 'Invoice':
      return {
        badgeColor: '#FBF1F0',
        icon: (
          <div className="flex-center" title={ent}>
            <SVGIcon name="InvoiceLogo" color="#D77982" />
          </div>
        )
      };
    case 'OfferedItem':
    case 'HoursWorklogEntry':
      return {
        badgeColor: '#FFF2E6',
        icon: (
          <div className="flex-center" title={ent}>
            <SVGIcon name="Worklog" color="#D7B848" />
          </div>
        )
      };
    case 'AntiVirusHealth':
      return {
        badgeColor: '#E2F3E8',
        icon: (
          <div className="flex-center" title={ent}>
            <SVGIcon name="AntivirusPolicy" color="#417054" />
          </div>
        )
      };
    case 'PatchHealth':
      return {
        badgeColor: '#E2F3E8',
        icon: (
          <div className="flex-center" title={ent}>
            <SVGIcon name="PatchLight" color="#417054" />
          </div>
        )
      };
    case 'Alert':
      return {
        badgeColor: '#FEEDDC',
        icon: (
          <div className="flex-center" title={ent}>
            <SVGIcon name="AlertIcon" color="#EB3F31" />
          </div>
        )
      };
    case 'WorkStation':
      return {
        badgeColor: '#F1DCF1',
        icon: (
          <div className="flex-center" title={ent}>
            <SVGIcon name="System" color="#AE39B2" />
          </div>
        )
      };
    case 'DataBackupHealth':
      return {
        badgeColor: '#F1E8FF',
        icon: (
          <div className="flex-center" title={ent}>
            <SVGIcon name="Backup" color="#B08AE7" />
          </div>
        )
      };
    case 'AssetSoftwareInventory':
      return {
        badgeColor: '#CAE5FA',
        icon: (
          <div className="flex-center" title={ent}>
            <SVGIcon name="SoftwareBundle" color="#6C96EB" />
          </div>
        )
      };
    default:
      return {
        badgeColor: '#ae39b24d',
        icon: (
          <div className="=flex-center" title={ent}>
            <SVGIcon name="Binary" color="#AE39B2" />
          </div>
        )
      };
  }
};

const getEntityIconMap = {
  Ticket: { iconName: 'TicketOutline', iconColor: '#ED0050' },
  Invoice: {
    iconName: 'InvoiceLogo',
    iconColor: '#D77982'
  },
  Client: { iconName: 'ClientLogo', iconColor: '#D7B848' },

  HoursWorklogEntry: {
    iconName: 'Worklog',
    iconColor: '#D7B848'
  },

  OfferedItem: {
    iconName: 'Worklog',
    iconColor: '#D7B848'
  },

  AntiVirusHealth: {
    iconName: 'AntivirusPolicy',
    iconColor: '#417054'
  },
  RequesterAssociation: { iconName: 'Requesters', iconColor: '#D7B848' },
  PatchHealth: {
    iconName: 'PatchLight',
    iconColor: '#417054'
  },

  AssetPatchDetail: {
    iconName: 'PatchLight',
    iconColor: '#417054'
  },

  Alert: {
    iconName: 'AlertIcon',
    iconColor: '#EB3F31'
  },

  WorkStation: {
    iconName: 'System',
    iconColor: '#AE39B2'
  },

  DataBackupHealth: {
    iconName: 'Backup',
    iconColor: '#B08AE7'
  },
  AssetSoftwareInventory: {
    iconName: 'SoftwareBundle',
    iconColor: '#6C96EB'
  },
  FeedbackSurveyResponse: {
    iconName: 'CustomerSatisfacationSurvey',
    iconColor: '#6C96EB'
  },
  AssetRemoteSession: {
    iconName: 'RemoteDesktop',
    iconColor: '#000000'
  },
  NMAsset: {
    iconName: 'NetworkMonitoring',
    iconColor: '#000000'
  },
  AllAssets: {
    iconName: 'System',
    iconColor: '#000000'
  }
};

export { getEntityIcon, getEntityIconMap };
